<template>
    <card
        :label-top-left="model.id === null ? $t('msg.createNote') : model.name"
        :label-bottom-left="model.id !== null ? $t('msg.note') : ''"
        icon="mdi-note-text-outline"
    >
        <v-progress-linear
                v-if="loading"
                indeterminate
        ></v-progress-linear>
        <template v-if="!loading">
            <v-btn-toggle
                    v-if="isTablet"
                    class="mb-4 my-toggle"
                    v-model="toggle"
                    mandatory
            >
                <v-btn
                        color="primary"
                        value="description"
                        elevation="0"
                >{{ $t('msg.description') }}</v-btn>
                <v-btn
                        color="primary"
                        value="list"
                        elevation="0"
                >{{ $t('msg.list') }}</v-btn>
            </v-btn-toggle>
            <div class="card__multi" :class="{'card__multi_mobile': isTablet}">
                <div
                        v-if="!isTablet || toggle === 'description'"
                        class="card__list"
                >
                    <v-form>
                        <div class="note-form">
                            <v-text-field
                                    :label="$t('msg.name')"
                                    v-model="model.name"
                                    :error-messages="errors.collect('name')"
                                    data-vv-name="name"
                                    v-validate="'required|max:255'"
                                    :dense="!isMobile"
                                    outlined
                                    hide-details="auto"
                                    @input="save()"
                            ></v-text-field>
                            <v-textarea
                                    :label="$t('msg.description')"
                                    v-model="model.desc"
                                    :error-messages="errors.collect('desc')"
                                    data-vv-name="desc"
                                    :dense="!isMobile"
                                    outlined
                                    hide-details="auto"
                                    @input="save()"
                            ></v-textarea>
                            <v-combobox
                                    v-model="model.tag"
                                    :label="$t('msg.markers')"
                                    :error-messages="errors.collect('tags')"
                                    data-vv-name="tags"
                                    multiple
                                    small-chips
                                    hide-selected
                                    clearable
                                    deletable-chips
                                    :dense="!isMobile"
                                    outlined
                                    hide-details="auto"
                                    @input="save()"
                            ></v-combobox>
                            <c-switch
                                    v-model="model.is_archive"
                                    hide-details="auto"
                                    :label="$t('msg.isArchive')"
                                    @change="save()"
                            ></c-switch>
                        </div>
                    </v-form>
                </div>
                <div
                        v-if="!isTablet || toggle === 'list'"
                        class="card__detail"
                >
                    <div
                            class="color-block color-block_green mt-0"
                            :class="{'color-block__mobile': $vuetify.breakpoint.xsOnly}"
                    >
                        <list
                                :note-id="model.id"
                        ></list>
                    </div>
                </div>
            </div>
        </template>
    </card>
</template>

<script>
import List from "../../components/block/Note/List/List";

export default {
    components: {List},
    data() {
        return {
            formLoading: false,
            modelLoading: false,
            model: {
                id: null,
                name: null,
                desc: null,
                tag: [],
                is_archive: null
            },
            delay: (function(){
                let timer = 0;
                return function(callback, ms){
                    clearTimeout(timer);
                    timer = setTimeout(callback, ms);
                };
            })(),
            toggle: 'description',
            loading: false
        }
    },
    computed: {
        isTablet() {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    methods: {
        loadModel() {
            this.loading = true;
            this.$store.dispatch('loadNote', {id: this.model.id})
                .then(res => {
                    this.model = res;
                    this.$store.commit('setBreadcrumbs', [{id: 1, name: this.model.name}]);
                })
                .finally(() => this.loading = false);
        },
        save() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.delay(() => this._save(), 1000);
                }
            });
        },
        _save() {
            let isNew = this.model.id === null;
            let action = isNew ? 'createNote' : 'editNote';
            this.$store.dispatch(action, {data: this.model, id: this.model.id, formErrors: this.errors})
                .then(res => {
                    if (isNew) {
                        this.model.id = res.id;
                        this.$router.push({name: 'note', params: {id: this.model.id}});
                    }
                    this.$store.commit('setBreadcrumbs', [{id: 1, name: this.model.name}]);
                });
        }
    },
    created() {
        this.model.id = this.$route.params.id !== undefined ? parseInt(this.$route.params.id) : null;
        if (this.model.id !== null) this.loadModel();
    }
}
</script>

<style lang="scss">
.note-form {
    .v-input {
        margin-top: 10px;

        &:first-child {
            margin-top: 0;
        }
    }
}
</style>